export enum QuizQuestionAnswerType {
  SLIDER = 'SLIDER',
  OPTION = 'OPTION',
  MADLIB = 'MADLIB',
}
